import React, { Suspense } from 'react'
import TransitionPage from '../../TransitionPage'

const SuspenseLoader: React.FC = ({ children }) => (
  <Suspense
    fallback={
      <>
        <TransitionPage message="loading" />
      </>
    }
  >
    {children}
  </Suspense>
)

export default SuspenseLoader
